import { gql } from 'graphql-tag'
import { AUTO_QUOTE_FIELDS } from '~/graphql/auto/fragments'

export const CREATE_HOME_QUOTE = gql`mutation createQuote($data: CreateQuoteInput!) {
  createQuote(data: $data) {
    id
    number
    transaction {
      id
      transactionStatus
      formSchema
      insufficientInfo
      underwritingResult {
        state
      }
      agent {
        id
      }
      commissionResult {
        heartRating
      }
      property {
        yearBuilt
        squareFootage
        roofYearBuilt
        totalBathrooms
        replacementCostDollars
        eDocs
        hasPool
        hasDogs
        hasGarage
        hasBasement
        hasBusiness
        hasDogBites
        hasLargeDogs
        hasSolarPanels
        daycareBusiness
        hasExoticAnimals
        primaryStoveHeating
        stories
        homeType
        roofShape
        foundationType
        foundationPierHeight
        familyUnits
        roofMaterial
        insuredStatus
        uninsuredPeriod
        buildingMaterial
        businessActivity
        canceledInsurance
        windstormMitigation
        windstormMitigationType
        windstormMitigationDevice
        ibhsFortifiedHome
        ibhsFortifiedHomeType
        ibhsFortifiedHomeHailSupplement
        wildfireMitigation
        wildfireMitigationType
        ruralFireProtectionPaymentsCurrent
        buildQuality
        lowestLevelFinished
      }
      coverage {
        primaryUse
        defaultsPackage
        autoInAgency
        dwellingDollars
        otherStructuresDollars
        personalPropertyDollars
        lossOfUseDollars
        liabilityDollars
        standardDeductibleDollars
        windHailDeductibleDollars
        hurricaneDeductibleDollars
        windHailRoofSettlement
        waterBackupType
        waterBackupDollars
        equipmentBreakdownDollars
        serviceLineDollars
        cyberDollars
        underConstruction
        homeshare
        homeshareLandlord
        mineSubsidenceDollars
        mineSubsidenceMulti {
          coverage
          coverageADollars
          coverageBDollars
          additionalLivingExpenseDollars
        }
        sinkhole
        earthquake {
          coverage
          deductibleDollars
          lossAssessmentDollars
        }
        watercraftHullDollars
        leadDollars
        escapedFuel
        windHailExclusion
        fortifiedRoofUpgrade
        windHailDeductibleDecline
        blanketLimits {
          jewelryDollars
          fursDollars
          camerasDollars
          musicalInstrumentsDollars
          computersDollars
          silverwareDollars
          fineArtsDollars
          wineDollars
          firearmsDollars
          chinaCrystalDollars
          coinsDollars
          stampsDollars
          cardsDollars
          collectiblesDollars
        }
        scheduledItems {
          category
          description
          valueDollars
          settlementMethod
          premiumCents
        }
      }
      flattenCoverage {
        autoInAgency
        blanketLimitCameras
        blanketLimitComputers
        blanketLimitFineArts
        blanketLimitFineChinaAndCrystal
        blanketLimitFirearms
        blanketLimitFurs
        blanketLimitJewelry
        blanketLimitMusicalInstruments
        blanketLimitOtherCollectibles
        blanketLimitRareCoins
        blanketLimitSilverware
        blanketLimitStamps
        blanketLimitTradingCards
        blanketLimitWine
        cyberDollars
        defaultsPackage
        dwellingDollars
        earthquakeCoverage
        earthquakeDeductibleDollars
        earthquakeLossAssessment
        equipmentBreakdown
        escapedFuel
        fortifiedRoofUpgrade
        homeshare
        homeshareLandlord
        hurricaneDeductibleDollars
        liabilityDollars
        leadPoisoning
        lossOfUseDollars
        mineSubsidenceDollars
        mineSubsidenceMultiAdditionalLivingExpense
        mineSubsidenceMultiCoverage
        mineSubsidenceMultiCovADollars
        mineSubsidenceMultiCovBDollars
        otherStructuresDollars
        personalPropertyDollars
        primaryUse
        scheduledItems {
          category
          description
          valueDollars
          settlementMethod
          premiumCents
        }
        buriedServiceLines
        sinkhole
        standardDeductibleDollars
        underConstruction
        waterBackupDollars
        waterBackupType
        watercraftHullDollars
        windHailDeductibleDecline
        windHailDeductibleDollars
        windHailExclusion
        windHailRoofSettlement
        workersCompDollars
        workersCompFullTimeEmployees
        fungiPropertyDollars
        fungiLiabilityDollars
      }
    }
  }
}`

export const CREATE_AUTO_QUOTE = gql`
  ${AUTO_QUOTE_FIELDS}
  mutation createAutoQuote($data: CreateAutoQuoteInput!) {
    createAutoQuote(data: $data) {
      ...AutoQuoteFields
      policy {
        accountID
      }
    }
  }
`
